export default "__VITE_ASSET__fd8e183b__"